/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const IsPearsonSettingParser = /* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('IS_PEARSON')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class IsPearsonSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return IsPearsonSettingParser.decode(input).map(res => new IsPearsonSetting(res));
    }
    static unsafeDecode(input) {
        return IsPearsonSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IsPearsonSettingParser.encode(data);
    }
    static schema() {
        return IsPearsonSettingParser.schema();
    }
}
